import React, { Component } from 'react';
import './Loader.css';

class Loader extends Component {

  render() {
    return (
      <div className="spinner">
        <div className="double-bounce1"></div>
        <div className="double-bounce2"></div>
      </div>
    );
  }
}

export default Loader;



/** WEBPACK FOOTER **
 ** ./src/components/Loader/index.js
 **/